import script from "./InspectionReport.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionReport.vue?vue&type=script&setup=true&lang=js"

import "./InspectionReport.vue?vue&type=style&index=0&id=6339a45f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6339a45f"]])

export default __exports__